import { Controller } from "@hotwired/stimulus"

// Rewrites the browser URL bar without triggering a navigation.
// Use it when a page is rendered at a canonical route (e.g. /profil) but should
// display a user-specific URL (e.g. /profil/hugovanho).
export default class extends Controller {
  static values = { url: String }

  connect() {
    if (this.urlValue && window.location.pathname !== this.urlValue) {
      history.replaceState(history.state, "", this.urlValue)
    }
  }
}
